import { TableAction } from "@shared/types/table";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GenericTable } from "../../../../../shared/components/GenericTable";
import { useConsumerListMissingTariff } from "../../hooks";

interface MissingTarrifContentProps {
  billDraftId: string;
  data:any
}

export const MissingTariffsContent: React.FC<MissingTarrifContentProps> = ({ billDraftId ,data}) => {
  const params = useParams();
  const [missingTariffCurrentPage, setMissingTariffCurrentPage] = useState(1);
  const navigate = useNavigate();
  console.log("billDraftId in missing tariff",billDraftId);
  console.log('list data of tarrif',data)
  // const { data: data } = useConsumerListMissingTariff(
  //   params?.id,
  //   billDraftId,
  //   missingTariffCurrentPage
  // );
  console.log("data in missing tariff",data);

  const itemsPerPage = 50;

  const missingTariffColumns = [
    // {
    //   key: "planName",
    //   header: "Plan Name",
    //   render: (value: any, row: any) => {
    //     return <span className="font-medium">{row.planName ?? "NA"}</span>;
    //   },
    // },
    // {
    //   key: "utilityService",
    //   header: "Service",
    //   render: (value: any) => {
    //     return Array.isArray(value) ? value.join(",") : value;
    //   },
    // },
    // {
    //   key: "firstName",
    //   header: "Consumers Affected",
    // },

     {
      key: "consumerNo",
      header: "Account Number",
    },
    {
      key: "consumerName", // Virtual key for combined name
      header: "Consumer Name",
      render: (value: any, row: any) => (
        <span className="font-medium">
          {row.firstName} {row.lastName}
        </span>
      ),
    },
    
  ];

  const missingTariffActions: TableAction<any>[] = [
    {
      label: "Assign Tariff",
      onClick: (row: any) => {
        navigate(
          `/plan-tarrif/plan-tarrif-landing?tab=plans&query=${row?.planName}`
        );
      },
    },
  ];

  return (
    <>
      {
        <GenericTable
          data={data?.results ?? []}
          columns={missingTariffColumns}
          rowKey="id"
          // actions={missingTariffActions}
          actionsType="buttons"
          loading={false}
          pagination={{
            currentPage: data?.pageNumber,
            totalPages: Math.ceil(data?.count / itemsPerPage),
            totalItems: data?.count || 0,
            itemsPerPage: itemsPerPage,
            startItem: (data?.pageNumber - 1) * itemsPerPage + 1,
            endItem: Math.min(
              data?.pageNumber * itemsPerPage,
              data?.count || 0
            ),
          }}
          onPageChange={setMissingTariffCurrentPage}
        />
      }
    </>
  );
};
